export function linkToNew() {
  return "/new";
}

export function linkToNewPatient() {
  return `${linkToNew()}/patient`;
}

export function linkToNewPatientDuplicates() {
  return `${linkToNewPatient()}/duplicates`;
}

export function linkToNewPatientStep1() {
  return `${linkToNewPatient()}/step1`;
}
export function linkToNewPatientStep2() {
  return `${linkToNewPatient()}/step2`;
}

export function linkToNewPatientStep2V2() {
  return `${linkToNewPatient()}/step2-v2`;
}
export const linkToNewPatientStep3 = () => {
  return `${linkToNewPatient()}/step3`;
};
export function linkToNewPatientRegistrationPayment(): string {
  return `${linkToNewPatient()}/registration-payment`;
}

export function linkToNewPatientComplete() {
  return `${linkToNewPatient()}/complete`;
}

export function linkToNewCards() {
  return `${linkToNew()}/cards`;
}

export function linkToNewCardsActivateCard() {
  return `${linkToNewCards()}/activate-card`;
}

export function linkToNewCardsRegistrationConfirmed() {
  return `${linkToNewCards()}/registration-confirmed`;
}

export function linkToNewCardsSendPin() {
  return `${linkToNewCards()}/send-pin`;
}

export function linkToNewCardsShowPin() {
  return `${linkToNewCards()}/show-pin`;
}
